module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-audi-9f3b02ccd46ea6a5d1ab3ac4845500e6.png";